import { render, staticRenderFns } from "./LayIntarTranslateZh.vue?vue&type=template&id=3e7519e8&scoped=true&"
import script from "./LayIntarTranslateZh.vue?vue&type=script&lang=js&"
export * from "./LayIntarTranslateZh.vue?vue&type=script&lang=js&"
import style0 from "./LayIntarTranslateZh.vue?vue&type=style&index=0&id=3e7519e8&lang=less&scoped=true&"
import style1 from "./LayIntarTranslateZh.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7519e8",
  null
  
)

export default component.exports